import { Col, Container, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useProductForm } from "../productModalForm";

const defaultValues = {
  imageProduct: null,
  image: "",
};

export const PresentationForm = () => {
  const { disabled } = useProductForm();

  const {
    register,
    formState: { errors },
    watch,
    setValue
  } = useFormContext({
    defaultValues: defaultValues,
  });

  const fileList = watch("imageProduct");

  const imageUrl = watch("image");

  const fileName =
    fileList && fileList.length > 0
      ? fileList[0].name
      : imageUrl?.split("/").pop();
  return (
    <Container>
      <h4>Imagen del producto</h4>
      <hr />
      <Row>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="imageProduct" className="form-label">
            Imagen del producto
          </label>
          <br />
          {fileName && (
            <div className="d-flex align-items-center gap-2">
              <span>{fileName}</span>
              <button
                type="button"
                className="btn btn-sm"
                onClick={() => {
                  setValue("image", "", { shouldDirty: true });
                  setValue("imageProduct", null);
                }}
              >
                X
              </button>
            </div>
          )}
          <input
            {...register("imageProduct", {
              validate: {
                isValidType: (files) => {
                  if (files && files.length > 0) {
                    const file = files[0];
                    const allowedTypes = ["image/png", "image/jpeg"];
                    return (
                      allowedTypes.includes(file.type) ||
                      "Solo se permiten imágenes PNG o JPG"
                    );
                  }
                  return true;
                },
                maxSize: (files) => {
                  if (files && files.length > 0) {
                    const file = files[0];
                    const maxSizeInBytes = 2 * 1024 * 1024;
                    return (
                      file.size <= maxSizeInBytes ||
                      "La imagen no debe pesar más de 2MB"
                    );
                  }
                  return true;
                },
              },
            })}
            id="imageProduct"
            type="file"
            className={`form-control ${!!errors?.imageProduct && "is-invalid"}`}
            accept=".png, .jpg, .jpeg"
            disabled={disabled}
          />
          {!!errors?.imageProduct && (
            <span className="error-message">
              {errors?.imageProduct?.message ||
                "Este campo no cumple las condiciones"}
            </span>
          )}
        </Form.Group>
      </Row>
    </Container>
  );
};
